import {Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AlgebraKiTService } from "src/app/modules/algebrakit/services/algebrakit.service";
import { ExerciseResult } from "src/app/modules/algebrakit/types/algebrakit.types";
import {Location} from '@angular/common'; 
import { THEMES, ThemeSpec } from "../../types/akit-testbench-types"
declare let AlgebraKIT: any;

const DEFAULT_EXERCISE_ID = 'fa42e943-8213-41a6-8a91-8c22a929ffe9';

@Component({
    templateUrl: "./player.container.html",
    styleUrls: ["./player.container.less"],
    selector: "app-player",
    standalone: false
})
export class PlayerContainer implements OnInit {
    public inputForm: UntypedFormGroup;
    public exerciseId: string;
    public sessionId: string;
    public viewMode: string; //solution, review, scoring, session
    public exerciseResult: ExerciseResult;
    public theme: ThemeSpec = THEMES[0];
    public assessmentMode = false;
    public themes = THEMES;
    public showSubheader = false;

    refId: string;  //if set, show only this interaction instead of the exercise

    sessionData: any;
    exerciseData: any;

    renderPromise: Promise<void>;
    renderResolve: () => void; //to resolve promise after render

    constructor(
        private formBuilder: UntypedFormBuilder,
        private akitService: AlgebraKiTService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location
    ) {
        if(!AlgebraKIT.config.behavior || !AlgebraKIT.config.behavior.general) AlgebraKIT.config.behavior = {general: {}};
        AlgebraKIT.config.behavior.general.externalSubmitButton = false;

    }

    async ngOnInit() {
        let id = this.route.snapshot.paramMap.get("id");
        if(!id) {
            id = this.akitService.getCurrentExerciseId();

            // if the exercise has not interactions, fallback to the default exercise
            let spec = this.akitService.getExerciseFromCache();
            if(spec && this.akitService.isEmptyExercise(spec)) id = null;

            if(!id) id = DEFAULT_EXERCISE_ID;
        }
        if(id) this.akitService.setCurrentExerciseId(id);
        this.exerciseId = id;

        this.inputForm = this.formBuilder.group({
            inputData: this.formBuilder.group({
                exerciseId: new UntypedFormControl(id),
                viewType: new UntypedFormControl(""),
                assessmentMode: new UntypedFormControl(""),
                theme: new UntypedFormControl(this.theme.id) 
            }),
        });

        this.inputForm.get('inputData.viewType').valueChanges.subscribe(_value => this.setView(_value));
        
        this.inputForm.get('inputData.theme').valueChanges.subscribe(_theme => {
            this.theme = THEMES.find(_t => _t.id == _theme)
            if(!this.theme) this.theme = THEMES[0];
            AlgebraKIT._api.changeTheme(this.theme.id);
            this.createSession();
        });
        this.inputForm.get('inputData.assessmentMode').valueChanges.subscribe(_assessmentMode => {
            this.assessmentMode = _assessmentMode;
        });
    }

    setView(_value: string) {
        this.viewMode = _value;
        if(_value && this.sessionId) {
            switch(_value) {
                case 'solution': 
                    break;
                case 'review': 
                    break;
                case 'scoring':
                    
                    this.akitService.getSessionScore(this.sessionId).subscribe(_exerciseResult => {
                        console.log(_exerciseResult);
                        this.exerciseResult = _exerciseResult;
                    });
                    break;
                case 'session': {
                    this.akitService.getSessionData(this.sessionId).subscribe(_sessionData => {
                        if(_sessionData && _sessionData.payload) {
                            delete _sessionData.payload.cache;
                        }
                        this.sessionData = _sessionData; //JSON.stringify(_sessionData, null, 2)
                    })
                    } 
                    break;
                case 'exercise': {
                    this.akitService.getExerciseData(this.exerciseId).subscribe(_exerciseData => {
                        this.exerciseData = _exerciseData;
                    })
                    break;
                }
            }
        }
    }

    onSessionCreated(sessionId: string) {
        this.sessionId = sessionId;
    }

    createSession() {
        this.refId = null;
        let id = this.inputForm.value.inputData.exerciseId;
        if(id != this.exerciseId) {
            // update the visible url
            const url = this.router.createUrlTree(['player',id], {}).toString()
            this.location.go(url);
        }
        if(id) {
            id = id.trim();
            if(this.exerciseId==id) {
                this.exerciseId=null;
                this.waitForRender().then(() => {
                    this.exerciseId = id;
                })
            } else {
                this.exerciseId = id;
                this.akitService.setCurrentExerciseId(id);
            }
        }
    }
    
    lockSession() {
        this.akitService.lockSession(this.sessionId);
    }

    showInteraction(refId: string) {
        this.refId = refId;
    }

    refreshResults() {
        let vm = this.viewMode;
        this.setView(null);
        this.waitForRender().then(() => {
            this.setView(vm);
        });
    }

    ngAfterViewChecked(): void {
        if (this.renderResolve) {
            this.renderPromise = null;
            this.renderResolve();
        }
    }

    waitForRender(): Promise<void> {
        if (!this.renderPromise) {
            this.renderPromise = new Promise((resolve, reject) => {
                this.renderResolve = resolve;
            });
        }
        return this.renderPromise;
    }

}
